'use client'
import { useSeti } from "../utils/useSeti.js";
const getFeatureConfig = (viewType, isChatbotOpened)=>{
    const shouldEnableModalUpdates = Boolean(useSeti({
        testName: 'PENNY_MODAL_UI_IMPROVEMENTS',
        shouldFireImpression: true
    }));
    const shouldEnablePortalUpdates = Boolean(useSeti({
        testName: 'PENNY_PORTAL_UI_IMPROVEMENTS',
        shouldFireImpression: true
    }));
    const shouldEnablePennyChatInput = Boolean(useSeti({
        testName: 'PENNY_PORTAL_UI_IMPROVEMENTS_EXPANDABLE_INPUT',
        shouldFireImpression: true
    }));
    const shouldEnableSelectTrip = Boolean(useSeti({
        testName: 'CHATBOT_TRIP_CARDS_SELECT_TRIP',
        shouldFireImpression: false
    }));
    const shouldPersonalizedGreeting = Boolean(useSeti({
        testName: 'PENNY_PORTAL_PERSONALIZATION_GREETING',
        shouldFireImpression: false
    }));
    const featureConfig = {
        LANDING: {
            isCaresSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                enableVoice: true,
                isCustomVoice: true,
                enableVoiceTooltip: true,
                isRealtime: true,
                shouldDisplayCheckoutButton: true,
                shouldDisplayGenHotelFeature: true,
                shouldEnableSelectTrip,
                shouldEnableModalUpdates,
                shouldRetrieveOnHover: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        PORTAL: {
            isCaresSurveyEligible: false,
            setiValues: {
                shouldPersonalizedGreeting,
                enableMyTripsSignIn: true,
                enableVoice: true,
                enableVoiceTooltip: true,
                isRealtime: true,
                isCustomVoice: true,
                shouldDisplayCheckoutButton: true,
                shouldDisplayGenHotelFeature: true,
                shouldEnableSelectTrip,
                shouldEnablePortalUpdates,
                shouldEnablePennyChatInput
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        STAYDETAILS: {
            isCaresSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                isRealtime: true,
                isCustomVoice: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        STAYLISTINGS: {
            isCaresSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                isRealtime: true,
                isCustomVoice: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        ITINERARY: {
            isCaresSurveyEligible: true,
            setiValues: {
                enableVoice: true,
                enableVoiceTooltip: true,
                isCaresSurveyEnabled: true,
                enableMyTripsSignIn: true,
                isRealtime: true,
                isCustomVoice: true,
                shouldEnableModalUpdates,
                shouldRetrieveOnHover: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        FLYDETAILS: {
            isCaresSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                isRealtime: false,
                isCustomVoice: false
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        FLYLISTINGS: {
            isCaresSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                isRealtime: false,
                isCustomVoice: false
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        DRIVE: {
            isCaresSurveyEligible: false,
            setiValues: {
                enableMyTripsSignIn: true,
                isRealtime: true,
                isCustomVoice: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        PACKAGE: {
            isCaresSurveyEligible: false,
            setiValues: {
                isRealtime: true,
                isCustomVoice: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        },
        CHECKOUT: {
            isCaresSurveyEligible: false,
            setiValues: {
                isRealtime: false,
                isCustomVoice: true
            },
            quickActionsStackVariant: 'HORIZONTAL'
        }
    };
    const config = featureConfig[viewType];
    if (!config) throw new Error(`No feature configuration found for viewType: ${viewType}. Add configuration to featureConfig object in /react-components/penny-chat-bot/src/config/featureConfig.ts. `);
    return config;
};
export { getFeatureConfig };
